<template>
    <section
        v-if="isValidCalendlyUrl"
        :id="slice.primary.anchorId || ''"
        :data-slice-type="slice.slice_type"
        :data-slice-variation="slice.variation"
        class="slice slice-calendly"
    >
        <div class="slice-content">
            <PrismicRichText v-if="slice.primary.title" class="slice-title" :field="slice.primary.title" />
            <PrismicRichText v-if="slice.primary.description" class="slice-description" :field="slice.primary.description" />
            <div class="calendly-inline-widget" :data-url="calendlyUrl" data-resize="true" />
        </div>
    </section>
</template>

<script setup lang="ts">
    import {onMounted, computed, ref} from 'vue';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {CalendlySlice} from '@prismicio-types';

    const props = defineProps(getSliceComponentProps<CalendlySlice>(['slice', 'index', 'slices', 'context']));

    onMounted(() => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.head.appendChild(script);
    });

    const calendlyUrl = ref<string>(props.slice.primary.calendlyUrl || '');

    const isValidCalendlyUrl = computed(() => {
        if (!calendlyUrl.value) return false;
        const regex = /^https:\/\/calendly\.com\/[a-zA-Z0-9\-_]+\/[a-zA-Z0-9\-_]+/;
        return regex.test(calendlyUrl.value);
    });
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .calendly-inline-widget {
        min-width: 320px;
        min-height: 680px;
    }

    .calendly-inline-widget iframe {
        @include mq.screen_sm() {
            margin-top: var(--joy-core-spacing-7);
        }
    }
</style>
